import useUsers from "@/hooks/useUsers";
import { userHasAccountAdminAccess } from "@/util";

/** Undefined until the current user loads. Matches save_project's admin check. */
export function useCanAddEnvironments(): boolean | undefined {
  const { loading, currentUser } = useUsers();
  return loading ? undefined : userHasAccountAdminAccess(currentUser);
}
